import { ChakraFlex, ChakraVStack } from '@equip.health/ui';
import DischargePlanViewSections from './DischargePlanViewSections';
import { ErrorBoundary } from 'react-error-boundary';
import { DischargePlanErrorFallback } from './DischargePlanErrorFallback';

const DischargePlanView = ({ patientId }: { patientId?: string }) => {
  return (
    <ChakraFlex
      flexDirection="column"
      id="discharge-plan-view"
      marginBottom="30px"
    >
      <ChakraVStack gap="18px" width="100%">
        <ErrorBoundary fallback={<DischargePlanErrorFallback />}>
          <DischargePlanViewSections patientId={patientId} />
        </ErrorBoundary>
      </ChakraVStack>
    </ChakraFlex>
  );
};

export default DischargePlanView;
